import { render, staticRenderFns } from "./ProfileEditTabEmails.vue?vue&type=template&id=e5bce138&scoped=true&"
import script from "./ProfileEditTabEmails.vue?vue&type=script&lang=js&"
export * from "./ProfileEditTabEmails.vue?vue&type=script&lang=js&"
import style0 from "./ProfileEditTabEmails.vue?vue&type=style&index=0&id=e5bce138&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bce138",
  null
  
)

export default component.exports